import dayjs from "dayjs";
import { CardTitle } from "@altimateai/lego";
import ProfileImageByUser from "../../../user/ProfileImageByUser";
import { User } from "../../../user/types";
import ResolveButton from "./ResolveButton";
import { ConversationGroup } from "./context/types";
import { DbtDocsShareDetails } from "../types";
import { Stack } from "@altimateai/lego";

interface Props {
  user?: User;
  timestamp: string;
  showResolveButton?: boolean;
  shareId: DbtDocsShareDetails["share_id"];
  conversationGroupId?: ConversationGroup["conversation_group_id"];
}
const ConversationHeader = ({
  user,
  timestamp,
  showResolveButton,
  conversationGroupId,
  shareId,
}: Props) => {
  return (
    <CardTitle>
      <Stack align="center" justify="between" className="mb-0">
        <Stack align="center">
          <ProfileImageByUser user={user} />
          <h4>
            {user?.first_name} {user?.last_name}
          </h4>
          <span>{dayjs(timestamp).format("HH:mm, DD MMM YY")}</span>
        </Stack>
        {showResolveButton ? (
          <ResolveButton
            conversationGroupId={conversationGroupId}
            shareId={shareId}
          />
        ) : null}
      </Stack>
    </CardTitle>
  );
};

export default ConversationHeader;
